import { render, staticRenderFns } from "./NotificationsDetail.vue?vue&type=template&id=36eeaa3d&lang=html&"
import script from "./NotificationsDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports